import ArrowCircleUpIcon from '@mui/icons-material/ArrowCircleUp';
import { Box, Button, FormControl, InputLabel, MenuItem, Select, TextField, Typography } from '@mui/material';
import { useScroll } from 'framer-motion';
import { FC, useEffect, useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import ScrollToTop from 'react-scroll-to-top';
import { Container, Modal, ModalBody, Spinner } from 'reactstrap';
import { styled, css } from 'styled-components';

import { config } from '../config/config';
import { OFICINA } from '../config/constants';
import { formSumate, formSumateInit } from '../models/types';
import { getQuestions, sendCV, sendQuestions } from '../services/questions.services';
import { setLoading } from '../stores/questionsSlice';
import { setKey, setToast } from '../stores/sharedSlice';
import { useAppDispatch, useAppSelector } from '../stores/store';
import { DescItems, Title, TitleSumate } from '../styled/intro';
import { azulRemax } from '../styled/const';
import Intro from '../componentes/sumate2/intro.component';
import { Answer } from '../models/Question';

const Sumate: FC = () => {
  const dispatch = useAppDispatch();

  // useEffect(() => {
  //   const loadingManager = async () => {
  //     try {
  //       dispatch(setLoading(true));
  //       const questions = await getQuestions();
  //       // setManager(new ManagerQuestions(questions));
  //     } catch (error) {
  //       console.error(error);
  //     } finally {
  //       dispatch(setLoading(false));
  //     }
  //   };

  //   loadingManager();
  // }, []);

  const [formData, setFormData] = useState<formSumate>(formSumateInit);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const sendAnswerRequest = async (respuestas: Answer[], cv: File) => {
    try {
      const solicitud = await sendQuestions({ questions: respuestas });
      const idPostulacion = solicitud.data.id;
      // ACA VA EL CV
      await sendCV(idPostulacion, cv);
    } catch (error) {
      console.error(error);
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    setModalLoading(true);
    e.preventDefault();
    // if (validate()) {
    const respuestas: Answer[] = [
      { question: 'Nombre', answer: formData.nombre },
      { question: 'Teléfono', answer: formData.telefono },
      { question: 'Correo electronico', answer: formData.email },
      { question: 'Edad', answer: formData.edad?.toString() ?? '' },
      { question: 'Donde vivis', answer: formData.barrio },
      { question: 'Nivel de estudios', answer: formData.estudios?.toString() ?? '' },
      { question: 'Profesion', answer: formData.profesion },
      { question: '¿Tenés experiencia en ventas?', answer: formData.experienciaEnVentas ? 'Si' : 'No' },
      { question: 'Actividad en la que trabajas actualmente', answer: formData.actividad },
      { question: '¿Estás dispuesto/a a asumir este desafío?', answer: formData.dedicacionFull ? 'Si' : 'No' },
      {
        question: '¿Por qué te gustaría emprender en el rubro inmobiliario?',
        answer: formData.descripcion
      },
      { question: 'LinkedIn', answer: formData.linkedin }
      // { question: 'CV', answer: formData.cv?.name || 'No subido' }
    ];
    await sendAnswerRequest(respuestas, formData.cv as File);
    dispatch(
      setToast({
        message: 'Tus respuestas ya fueron enviadas, las analizaremos y te contactaremos, gracias',
        type: 'SUCCESS'
      })
    );
    setFormData(formSumateInit);
    setModalLoading(false);
    // }
  };

  useEffect(() => {
    dispatch(setKey('Sumate'));
  }, []);

  const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
  const isTablet = useMediaQuery({ query: '(min-width: 769px) and (max-width: 1024px)' });
  const isDesktop = useMediaQuery({ query: '(min-width: 1025px)' });

  const titulo = config.TITULO;
  const { scrollYProgress } = useScroll();

  const [modalLoading, setModalLoading] = useState(false);

  const clickA = () => {
    setFormData({ ...formSumateInit, cv: null });
  };

  return (
    <>
      <Modal returnFocusAfterClose={true} isOpen={modalLoading}>
        <ModalBody style={{ textAlign: 'center' }}>
          <Spinner
            color="primary"
            style={{
              height: '3rem',
              width: '3rem'
            }}
          >
            Loading...
          </Spinner>
        </ModalBody>
      </Modal>
      <ScrollToTop smooth component={<ArrowCircleUpIcon />} style={{ left: '30px' }} />
      <Intro isMobile={isMobile} isTablet={isTablet} isDesktop={isDesktop} />
      <section id="formulario" className="pb-1 pt-1" style={{ backgroundColor: azulRemax }}>
        <Container style={{ padding: '1.5em', textAlign: 'center' }}>
          <TitleSumate style={{ paddingBottom: '0.5em', display: 'flex', flexDirection: 'column' }}>
            Se parte de nuestra familia de Agentes <strong>{OFICINA}</strong>
          </TitleSumate>
          <DescItems className='font-main'>
            Buscamos personas apasionadas, con o sin experiencia en el sector, que quieran nuevos desafíos. Completá el
            formulario con tus datos y nuestro equipo se pondrá en contacto para que juntos construyamos el próximo
            capítulo de tu carrera
          </DescItems>
        </Container>
        <Container
          className="mt-5 mb-5"
          style={{
            padding: '1em',
            backgroundColor: '#fff',
            border: `2px solid ${azulRemax} !important`,
            borderRadius: '10px'
          }}
        >
          <Container className="mb-5 mt-5 font-main" style={{ textAlign: 'center' }}>
            <Typography gutterBottom sx={{ color: 'text.secondary', fontSize: 14 }} className='font-main'>
              Sumate a nuestra familia
            </Typography>
            <Typography variant="h5" component="div" className='font-main'>
              ¿Listo para empezar?
            </Typography>
            <Typography variant="h6" component="div" className='font-main'>
              Respondé unas preguntas y nos contactaremos
            </Typography>
          </Container>
          <Box
            component="form"
            onSubmit={handleSubmit}
            className="mt-5 mb-5"
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 2,
              margin: '0 auto'
            }}
          >
            <TextField
              label="Nombre"
              name="nombre"
              value={formData.nombre}
              onChange={handleChange}
              fullWidth
              required
              className='font-main'
              // error={Boolean(errors.nombre)}
              // helperText={errors.nombre}
            />
            <TextField
              label="Teléfono"
              name="telefono"
              value={formData.telefono}
              onChange={handleChange}
              fullWidth
              required
              className='font-main'
            />
            <TextField
              label="Correo electronico"
              name="email"
              value={formData.email}
              onChange={handleChange}
              fullWidth
              type="email"
              required
              className='font-main'
            />
            <TextField
              label="Edad"
              name="edad"
              value={formData.edad}
              onChange={handleChange}
              type="text"
              fullWidth
              required
              className='font-main'
            />
            <TextField
              label="Donde vivis"
              name="barrio"
              value={formData.barrio}
              onChange={handleChange}
              fullWidth
              required
              className='font-main'
            />
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Nivel de estudios</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={formData.estudios}
                required
                label="Nivel de estudios"
                onChange={e => setFormData({ ...formData, estudios: e.target.value as formSumate['estudios'] })}
                className='font-main'
              >
                <MenuItem value={'Secundaria'}>Secundaria</MenuItem>
                <MenuItem value={'Terciario'}>Terciario</MenuItem>
                <MenuItem value={'Universitario'}>Universitario</MenuItem>
                <MenuItem value={'Posgrado'}>Posgrado</MenuItem>
                <MenuItem value={'Otros'}>Otros</MenuItem>
              </Select>
            </FormControl>
            <TextField
              label="Profesion"
              name="profesion"
              value={formData.profesion}
              onChange={handleChange}
              fullWidth
              required
              className='font-main'
            />
            <FormControl fullWidth>
              <InputLabel id="ventas-select-label">¿Tenés experiencia en ventas?*</InputLabel>
              <Select
                required
                labelId="ventas-select-label"
                id="ventas-simple-select"
                value={formData.experienciaEnVentas !== null ? (formData.experienciaEnVentas ? '1' : '0') : ''}
                label="¿Tenés experiencia en ventas?"
                onChange={e => setFormData({ ...formData, experienciaEnVentas: e.target.value === '1' })}
                className='font-main'
              >
                <MenuItem value={'1'}>Si</MenuItem>
                <MenuItem value={'0'}>No</MenuItem>
              </Select>
            </FormControl>
            <TextField
              label="Actividad en la que trabajas actualmente"
              name="actividad"
              value={formData.actividad}
              onChange={handleChange}
              fullWidth
              required
              className='font-main'
            />
            <FormControl fullWidth>
              <InputLabel id="dedicacion-select-label" className='font-main'>
                Sumamos a nuestro equipo de Agentes, perfiles que puedan dedicarse full time al negocio ¿Estás
                dispuesto/a a asumir este desafío?*
              </InputLabel>
              <Select
                required
                labelId="dedicacion-select-label"
                id="dedicacion-simple-select"
                value={formData.dedicacionFull !== null ? (formData.dedicacionFull ? '1' : '0') : ''}
                onChange={e => setFormData({ ...formData, dedicacionFull: e.target.value === '1' })}
                label="Sumamos a nuestro equipo de Agentes, perfiles que puedan dedicarse full time al negocio ¿Estás
          dispuesto/a a asumir este desafío?"
                className='font-main'
              >
                <MenuItem value={'1'}>Si</MenuItem>
                <MenuItem value={'0'}>No</MenuItem>
              </Select>
            </FormControl>
            <TextField
              label="Teniendo en cuenta que un agente inmobiliario no cuenta con un sueldo básico ni tampoco implica una relación de dependencia, ¿por qué te gustaría emprender en el rubro inmobiliario?"
              name="descripcion"
              value={formData.descripcion}
              onChange={handleChange}
              fullWidth
              multiline
              rows={4}
              required
              className='font-main'
            />
            <TextField
              label="LinkedIn"
              name="linkedin"
              value={formData.linkedin}
              onChange={handleChange}
              fullWidth
              type="url"
              className='font-main'
            />
            <TextField
              type="file"
              inputProps={{
                accept: 'application/pdf'
              }}
              onChange={e => {
                const file = (e.target as HTMLInputElement).files?.[0];
                if (file) {
                  if (file.size > 10 * 1024 * 1024) {
                    dispatch(setToast({ message: 'El archivo debe ser menor a 10MB', type: 'ERROR' }));
                    e.target.value = ''; // Clear the input
                  } else {
                    setFormData({ ...formData, cv: file });
                  }
                }
              }}
              fullWidth
              helperText="Sube tu CV en formato PDF (máximo 10MB)"
            />
            {/* <Button
              type="button"
              onClick={() => clickA()}
              className="background-azul"
              variant="contained"
              color="primary"
              fullWidth
            >
              <b>Enviar2</b>
            </Button> */}
            <Button type="submit" className="background-azul" variant="contained" color="primary" fullWidth>
              <b>Enviar</b>
            </Button>
          </Box>
        </Container>
      </section>
    </>
  );
};

export default Sumate;
